// Libraries
import { m } from "framer-motion";
import { Col, Container, Navbar, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Trans, useTranslation } from "react-i18next";

// Animation
import { fadeIn } from "@/Functions/GlobalAnimations";

// Components
import Clients from "@/Components/Clients/Clients";
import FooterMenu, { Footer } from "@/Components/Footers/Footer";
import Header, {
  CollapsibleMenu,
  HamburgerMenu,
  HeaderNav,
} from "@/Components/Header/Header";
import PortfolioColorful from "@/Components/Portfolio/PortfolioColorful";
import ReactCustomScrollbar from "@/Components/ReactCustomScrollbar";
import { ClientData06 } from "@/Components/Clients/ClientsData";
import FooterData from "@/Components/Footers/FooterData";
import { ProfileButton } from "@/Features/User";
import HomeSlider from "@/Components/HomeSlider/HomeSlider";
import Show4News from "@/Components/News/Show4News";
import { ProductsAndStacks } from "@/Components/Products/ProductsAndStacks";

const portfolioColorfulData = [
  {
    title: "page.main.portfolio.0.title",
    img: "page.main.portfolio.0.img",
    category: [""],
    subtitle: "page.main.portfolio.0.subtitle",
    link: "/contact-center",
    double_col: true,
  },
  {
    title: "page.main.portfolio.1.title",
    img: "page.main.portfolio.1.img",
    category: [""],
    subtitle: "page.main.portfolio.1.subtitle",
    link: "/speechintellect",
  },
  {
    title: "page.main.portfolio.2.title",
    img: "page.main.portfolio.2.img",
    category: [""],
    subtitle: "page.main.portfolio.2.subtitle",
    link: "#",
  },
  {
    title: "page.main.portfolio.3.title",
    img: "page.main.portfolio.3.img",
    category: [""],
    subtitle: "page.main.portfolio.3.subtitle",
    link: "/sense-profile",
    double_col: true,
  },
  {
    title: "page.main.portfolio.4.title",
    img: "page.main.portfolio.4.img",
    category: [""],
    subtitle: "page.main.portfolio.4.subtitle",
    link: "https://s2schat.com",
  },
  {
    title: "page.main.portfolio.5.title",
    img: "page.main.portfolio.5.img",
    category: [""],
    subtitle: "page.main.portfolio.5.subtitle",
    link: "#",
  },
];

const TestimonialsCarouselData = [
  {
    content: "page.main.reviews.items.0.content",
    firstname: "page.main.reviews.items.0.firstname",
    lastname: "page.main.reviews.items.0.lastname",
    post: "page.main.reviews.items.0.post",
  },
  {
    content: "page.main.reviews.items.1.content",
    firstname: "page.main.reviews.items.1.firstname",
    lastname: "page.main.reviews.items.1.lastname",
    post: "page.main.reviews.items.1.post",
  },
  {
    content: "page.main.reviews.items.2.content",
    firstname: "page.main.reviews.items.2.firstname",
    lastname: "page.main.reviews.items.2.lastname",
    post: "page.main.reviews.items.2.post",
  },
];

const FooterMenuData = [FooterData[0], FooterData[3]];

const CreativeAgencyPage = (props) => {
  const { t } = useTranslation();
  return (
    <div
      className="pl-[260px] md:pl-0 bg-base-main overflow-hidden smooth-scrollbar"
      style={props.style}
    >
      {/* Header Start */}
      <Header
        topSpace={{ md: true }}
        type="pos-left"
        className="w-[260px] h-[100vh] z-10 md:w-full md:h-auto relative"
      >
        <div className="!absolute top-4 left-0 flex w-full justify-between items-center px-8">
          <ProfileButton />
          {/* <ChangeLanguage /> */}
        </div>

        <div className="flex justify-between flex-col h-full bg-richgray text-base-main border-r border-[#ffffff1a] pt-20 px-8 overflow-hidden md:pt-40 md:hidden">
          <Col xs="auto" className="text-center leading-none">
            <Link
              aria-label="header logo"
              to="/"
              firsttitle
              className="inline-block leading-none"
            >
              <Navbar.Brand className="inline-block p-0 m-0">
                <img
                  className="default-logo !max-h-max"
                  loading="lazy"
                  src="/assets/img/logo/erllecta_logo.svg"
                  data-rjs="/assets/img/logo/erllecta_logo.svg"
                  alt="logo"
                />
                <img
                  className="mobile-logo"
                  loading="lazy"
                  src="/assets/img/logo/erllecta_logo.svg"
                  data-rjs="/assets/img/logo/erllecta_logo.svg"
                  alt="logo"
                />
              </Navbar.Brand>
            </Link>
          </Col>
          <Col xs="auto" className="pl-[15px] max-h-[calc(100%-160px)]">
            <ReactCustomScrollbar
              className="!items-start"
              autoHide
              theme="dark"
            >
              <div>
                <CollapsibleMenu
                  className="left-sidebar-menu w-full"
                  theme="dark"
                />
              </div>
            </ReactCustomScrollbar>
          </Col>
          <Col xs="auto" className="mb-20 py-8">
            <span className="block text-center text-xs text-spanishgray">
              &copy; 2023-{new Date().getFullYear()}{" "}
              <Trans
                i18nKey="footer.copyright"
                components={{ redText: <span class="text-red"></span> }}
              />
            </span>
          </Col>
        </div>

        {/* Mobile menu start */}
        <HeaderNav
          className="hidden md:flex justify-between px-[30px] sm:pl-[15px] md:py-[15px]"
          containerClass="px-0"
        >
          <Link className="flex items-center justify-center" to="/">
            <Navbar.Brand className="inline-block p-0 m-0">
              <img
                src="/assets/img/logo/erllecta_logo.svg"
                className="max-h-[36px]"
                alt="logo"
              />
            </Navbar.Brand>
          </Link>
          <HamburgerMenu
            theme="dark"
            position="left"
            className="w-[260px] flex flex-col justify-end"
            closeBtn={false}
          >
            <div
              className="bg-[#c8cfd4] px-8 pb-20 relative"
              style={{ height: `calc(100vh - var(--header-height))` }}
            >
              <div className="!absolute top-4 left-0 flex w-full justify-between items-center px-8">
                <ProfileButton />
                {/* <ChangeLanguage /> */}
              </div>

              <ReactCustomScrollbar
                autoHide
                className="pl-[15px] mt-[50px] !items-start"
              >
                <div>
                  <CollapsibleMenu
                    className="w-full left-sidebar-menu"
                    theme="dark"
                  />
                </div>
              </ReactCustomScrollbar>
            </div>
          </HamburgerMenu>
        </HeaderNav>
        {/* Mobile menu end */}
      </Header>
      {/* Header End */}

      {/* Section Start */}
      <section className="p-0 overflow-hidden">
        <HomeSlider />
      </section>
      {/* Section End */}

      {/* About Section Start */}
      <section className="py-[200px] overflow-hidden lg:py-[160px] md:py-[110px] sm:py-[50px]">
        <Container>
          <Row>
            <Col md={5}>
              <span className="font-semibold text-primary-main text-xmd font-serif uppercase tracking-[1px] block sm:mb-[20px]">
                {t("page.main.awards.title")}
              </span>
            </Col>
            <Col md={7}>
              <m.h2
                className="heading-5 leading-[50px] font-serif mb-[74px] w-[95%] sm:w-full md:mb-[45px] lg:leading-normal"
                {...fadeIn}
              >
                <span className="font-semibold text-[#fff]">
                  {t("page.main.awards.description.strong")}{" "}
                </span>
                {t("page.main.awards.description.text")}
              </m.h2>
              <m.div
                className="row"
                {...{ ...fadeIn, transition: { delay: 0.5 } }}
              >
                <Col xl={5} md={6} className="sm:mb-[40px]">
                  <div className="h-[1px] bg-basecolor w-full inline-block mb-[49px] md:mb-[30px]"></div>
                  <span className="mb-[15px] font-medium text-primary-main text-lg font-serif block md:text-xmd">
                    {t("page.main.awards.branding.title")}
                  </span>
                  <p className="mb-0 w-[95%] leading-[30px] text-xmd">
                    {t("page.main.awards.branding.description")}
                  </p>
                </Col>
                <Col xl={{ span: 5, offset: 2 }} md={6}>
                  <div className="h-[1px] bg-basecolor w-full inline-block mb-[49px] md:mb-[30px]"></div>
                  <span className="mb-[15px] font-medium text-primary-main text-lg font-serif block md:text-xmd">
                    {t("page.main.awards.digital.title")}
                  </span>
                  <p className="mb-0 w-[95%] leading-[30px] text-xmd">
                    {t("page.main.awards.digital.description")}
                  </p>
                </Col>
              </m.div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* About Section End */}

      {/* Portfolio Section Start */}
      <section>
        <Container fluid className="px-0">
          <Row>
            <Col>
              <PortfolioColorful
                className="m-0"
                overlay="#D93535B3"
                grid="grid grid-4col xl-grid-4col lg-grid-2col md-grid-2col sm-grid-2col xs-grid-1col text-center"
                data={portfolioColorfulData}
              />
            </Col>
          </Row>
        </Container>
      </section>
      {/* Portfolio Section End */}

      {/* Stack Section Start */}
      <ProductsAndStacks />
      {/* Stack Section End */}

      {/* Client Section Start */}

      {/* Временно скрыли по просьбе заказчика, вернется по требованию с возможно частичной заменой некоторых клиентов */}
      {/* <section className="py-[200px] lg:py-[160px] md:py-[110px] sm:py-[50px]">
        <Container>
          <m.div className="row" {...fadeIn}>
            <Col md={5} className="sm:mb-[20px]">
              <span className="font-semibold text-basecolor text-xmd font-serif uppercase block tracking-[1px]">
                {t("page.main.valuable_clients.title")}
              </span>
            </Col>
            <Col md={7}>
              <h2 className="heading-5 w-[95%] leading-[50px] font-serif md:leading-normal md:w-[90%] md:mb-0">
                {t("page.main.valuable_clients.description.0")}
                <span className="font-semibold text-white">
                  {" "}
                  {t("page.main.valuable_clients.description.1")}{" "}
                </span>
                {t("page.main.valuable_clients.description.2")}
              </h2>
            </Col>
          </m.div>
          <Row className="mt-[9.5rem] justify-center lg:mt-24">
            <Clients
              grid="row-cols-1 row-cols-sm-2 row-cols-md-4"
              theme="client-logo-style-06"
              data={ClientData06}
              animation={fadeIn}
            />
          </Row>
        </Container>
      </section> */}
      {/* Client Section End */}

      {/* Testimonial Section Start */}
      <section
        className="py-[200px] lg:py-[160px] md:py-[110px] sm:py-[50px] cover-background"
        style={{
          backgroundImage: `url(/assets/img/webp/home-creative-agency-testimonials-bg.webp)`,
        }}
      >
        <Container>
          <m.div className="row" {...fadeIn}>
            <Col md={5} className="md:mb-[20px]">
              <span className="font-semibold text-basecolor text-xmd font-serif uppercase block tracking-[1px]">
                {t("page.main.reviews.title")}
              </span>
            </Col>
            <Col md={7}>
              <Swiper
                className="testimonial-carousel-style-05"
                loop={true}
                slidesPerView={1}
                modules={[Autoplay]}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
              >
                {TestimonialsCarouselData.map((item, i) => {
                  return (
                    <SwiperSlide key={i}>
                      <div className="cursor-ew-resize">
                        {item.content && (
                          <h2 className="heading-6 w-[92%] mb-28 leading-[44px] font-serif sm:leading-[34px] sm:w-full sm:mb-16">
                            <Trans
                              i18nKey={item.content}
                              components={{
                                redText: <span class="text-red"></span>,
                              }}
                            />
                          </h2>
                        )}
                        <h3 className="heading-6 font-light text-primary-main mb-[5px] md:leading-normal">
                          <span
                            className="font-semibold"
                            contentEditable={false}
                          >
                            {t(item.firstname)}
                          </span>{" "}
                          {t(item.lastname)}
                        </h3>
                        {item.post && (
                          <span className="text-lg font-serif">
                            {t(item.post)}
                          </span>
                        )}
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </Col>
          </m.div>
        </Container>
      </section>
      {/* Testimonial Section End */}

      {/* Blog Section Start */}
      <section className="pt-[200px] lg:pt-[160px] md:pt-[110px] sm:pt-[50px]">
        <Container>
          <Row className="mb-[108px] justify-between sm:flex-col sm:mb-[40px] xs:mb-[4.5rem]">
            <Col xs="auto" className="xs:mb-[20px]">
              <span className="font-semibold text-basecolor text-xmd tracking-[1px] font-serif uppercase inline-block">
                {t("common:news.latest_news")}
              </span>
            </Col>
            <Col xs="auto">
              <a
                href="https://vc.ru/tag/it"
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-primary-main font-serif uppercase btn-link after:h-[1px] sm:text-left md:mb-[15px] after:bg-spanishgray hover:text-spanishgray xs:mb-0"
              >
                {t("common:news.read_news")}
              </a>
            </Col>
          </Row>
        </Container>
        <Container fluid className="px-12 xs:px-0">
          <Show4News />
        </Container>
        <Container fluid>
          <Row>
            <Col xs={12} className="text-center my-[10.5rem] md:my-[7.5rem]">
              <h2 className="heading-5 font-serif font-light -tracking-[1px]">
                {t("page.main.news.title") + " "}
                <Link
                  aria-label="start a project"
                  className="ml-[4px] relative font-semibold text-basecolor text-primary-main cursor-pointer -tracking-[1px] font-serif border-b-[1px] border-basecolor hover:border-white"
                  to="/contacts"
                >
                  {t("page.main.news.description")}
                </Link>
              </h2>
            </Col>
          </Row>
        </Container>
      </section>
      {/* Blog Section End */}

      {/* Footer Start */}
      <Footer
        parallax={{ desktop: false, md: false }}
        className="creative-footer border-t border-[#ffffff1a] bg-richgray text-base-main"
      >
        <div className="pt-[9%] lg:py-[8%] md:py-[50px]">
          <Container>
            <Row className="justify-start md:text-start">
              <Col
                xl={{ span: 3, order: 0 }}
                md={6}
                sm={{ span: 6, order: 1 }}
                className="lg:mb-[50px] xs:mb-[25px]"
              >
                <Link aria-label="Follow" to="/" className="mb-[40px] block">
                  <img
                    src="/assets/img/logo/erllecta_logo.svg"
                    alt="logo"
                    width="45"
                    height="52"
                    className="max-h-min w-36 -ml-[9px]"
                  />
                </Link>
                <p className="font-serif font-light w-[100%] mb-0 md:w-[80%] sm:w-[100%] text-xlg leading-[36px] -tracking-[0.5px] xs:w-11/12 text-[#828282] lg:text-lg lg:leading-[26px]">
                  {t("footer.description", { char: "&nbsp;" })}
                </p>
              </Col>
              <FooterMenu
                data={FooterMenuData}
                xl={{ span: 2, order: 0, offset: 1 }}
                sm={{ span: 6, order: 3 }}
                titleClass="uppercase"
                className="xs:mb-[25px]"
              />
              <Col
                xs={11}
                xl={{ span: 2, order: 0 }}
                md={6}
                sm={{ span: 6, order: 2 }}
                className="ml-auto max-w-[210px] w-max lg:ml-0 lg:max-w-none"
              >
                <span className="font-serif tracking-[2px] uppercase font-medium block mb-[30px] text-left">
                  <p>{t("footer.social")}</p>
                </span>
                <Trans i18nKey="footer.address" components={{ br: <br /> }} />
                <br />
                <p>
                  <a href="mailto:info@erllecta.ru">info@erllecta.ru</a>
                </p>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="py-[6.4rem] xs:pt-0 xs:px-0">
          <Container>
            <Row>
              <Col
                sm={{ span: 12, order: 2 }}
                md={{ span: 5, order: 1 }}
                xs={{ order: 2 }}
                className="text-start flex sm:justify-center md:text-end xs:justify-start"
              >
                <p className="text-xmd">
                  &copy; {new Date().getFullYear()}{" "}
                  <Trans
                    i18nKey="footer.copyright"
                    components={{ redText: <span class="text-red"></span> }}
                  />
                </p>
              </Col>
              <Col
                sm={{ span: 12, order: 1 }}
                md={{ span: 7, order: 2 }}
                xs={{ order: 1 }}
                className="sm:mb-[15px]"
              >
                <ul className="flex justify-end sm:justify-center xs:flex-col">
                  <li className="mr-[35px] md:mr-[20px] xl:mb-0 xs:mb-[7px]">
                    <Link
                      className="text-xmd leading-[34px] whitespace-nowrap"
                      aria-label="Privacy policy"
                      target="_blank"
                      to="/assets/documents/privacy_policy.pdf"
                    >
                      {t("footer.privacy_policy")}
                    </Link>
                  </li>
                  <li className="mr-[0px] xl:mb-0">
                    <Link
                      className="text-xmd leading-[34px] whitespace-nowrap"
                      aria-label="Terms of service"
                      target="_blank"
                      to="/assets/documents/terms_and_conditions.pdf"
                    >
                      {t("footer.terms_of_service")}
                    </Link>
                  </li>
                </ul>
              </Col>
            </Row>
          </Container>
        </div>
      </Footer>
      {/* Footer End */}
    </div>
  );
};

export default CreativeAgencyPage;
